import { TFunction } from 'next-i18next'
import { BigSale } from 'src/core/models'
import { getBigSaleUnit, getFormatedPrice } from 'src/core/helpers'

export interface ProjectSaleDetailLabels {
  label: string,
  strongLabel: string | number,
  secondLabel?: string,
}

export const projectCurrencyLabels = (t: TFunction, sale: BigSale): ProjectSaleDetailLabels[] => [
  {
    label: t('Transactions.Amount'),
    strongLabel: sale.co2_amount,
    secondLabel: getBigSaleUnit(sale),
  },
  {
    label: t('Transactions.UnitPrice'),
    strongLabel: getFormatedPrice(sale.project_currency_token_price, sale.projectCurrencyCode),
  },
  {
    label: t('Transactions.VAT'),
    strongLabel: getFormatedPrice(+sale.projectCurrencyVatAmount, sale.projectCurrencyCode),
  },
  {
    label: t('Deposits.Total'),
    strongLabel: getFormatedPrice(+sale.project_currency_amount, sale.projectCurrencyCode),
  },
]

export const customerCurrencyLabels = (t: TFunction, sale: BigSale): ProjectSaleDetailLabels[] => [
  {
    label: t('Transactions.UnitPrice'),
    strongLabel: getFormatedPrice(sale.token_price, sale.currencyTokenCode),
  },
  {
    label: t('Deposits.Total'),
    strongLabel: getFormatedPrice(sale.amount, sale.currencyTokenCode),
  },
]

export const supplierInvoiceLabels = (t: TFunction, sale: BigSale): ProjectSaleDetailLabels[] => [
  {
    label: t('Transactions.Amount'),
    strongLabel: sale.co2_amount,
    secondLabel: getBigSaleUnit(sale),
  },
]
